import { render, staticRenderFns } from "./GallerySettings.vue?vue&type=template&id=90deb190&scoped=true&"
import script from "./GallerySettings.vue?vue&type=script&lang=js&"
export * from "./GallerySettings.vue?vue&type=script&lang=js&"
import style0 from "./GallerySettings.vue?vue&type=style&index=0&id=90deb190&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90deb190",
  null
  
)

export default component.exports